// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import timeEntryApprovalEntity from './entities/time-entry-approval.json';
import timeEntryApprovalMenu from '../pages/time-entry-approval/menu.json';
import timeEntryApprovalFullForm from '../pages/time-entry-approval/forms/full.json';
import timeEntryApprovalContextForm from '../pages/time-entry-approval/forms/context.json';
import timeEntryApprovalMiniForm from '../pages/time-entry-approval/forms/mini.json';
import timeEntryApprovalLookupForm from '../pages/time-entry-approval/forms/lookup.json';
import timeEntryApprovalTableView from '../pages/time-entry-approval/views/table.json';
import timeEntryApprovalCardsView from '../pages/time-entry-approval/views/cards.json';
import timeEntryApprovalDashboardView from '../pages/time-entry-approval/views/dashboard.json';

/** Тип запису «Затвердження табеля» зі сторінками пакета: меню, форми та подання з pages/time-entry-approval/. */
export const timeEntryApprovalDefinition: IRecordTypeDefinition = {
  ...timeEntryApprovalEntity,
  views: assembleViewSet({
      table: timeEntryApprovalTableView,
      cards: timeEntryApprovalCardsView,
      dashboard: timeEntryApprovalDashboardView,
  }),
  form: timeEntryApprovalFullForm,
  forms: { full: timeEntryApprovalFullForm, context: timeEntryApprovalContextForm, mini: timeEntryApprovalMiniForm, lookup: timeEntryApprovalLookupForm },
  menu: timeEntryApprovalMenu,
} as IRecordTypeDefinition;
